import { render, staticRenderFns } from "./mobileBottom.vue?vue&type=template&id=3954c8e5"
import script from "./mobileBottom.vue?vue&type=script&lang=js"
export * from "./mobileBottom.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/home/mobileBottom.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports